import {
  Activity,
  AlertTriangle,
  ArrowRight,
  ArrowUpRight,
  Briefcase,
  Bug,
  BookOpen,
  Calendar,
  Check,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChartCandlestick,
  ChartNoAxesColumn,
  Clock,
  Copy,
  CreditCard,
  Eye,
  EyeOff,
  Gem,
  Gift,
  Grid3x3,
  File,
  FileSpreadsheet,
  FileText,
  HelpCircle,
  History,
  Home,
  Handshake,
  Image,
  Instagram,
  List,
  Send,
  Laptop,
  LayoutDashboard,
  Link,
  LayoutPanelLeft,
  LineChart,
  Loader2,
  LogOut,
  LucideIcon,
  LucideProps,
  MessagesSquare,
  Smartphone,
  Moon,
  MoreVertical,
  Package,
  Plus,
  Puzzle,
  Radar,
  RefreshCw,
  Search,
  Settings,
  Sparkles,
  SunMedium,
  Trash,
  TrendingUp,
  User,
  Users,
  X,
  BellRing,
  SwatchBook,
  MonitorCheck, 
  SlidersVertical,
  Zap,
  Waves,
  Bot,
  Brain,
  Calculator,
  Compass,
  Play,
  Target,
} from "lucide-react";

export type Icon = LucideIcon;

export const Icons = {
  activity: Activity,
  add: Plus,
  bug: Bug,
  arrowRight: ArrowRight,
  arrowUpRight: ArrowUpRight,
  billing: CreditCard,
  bell: BellRing,
  smartphone: Smartphone,
  bookOpen: BookOpen,
  brain: Brain,
  briefcase: Briefcase,
  calendar: Calendar,
  clock: Clock,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  check: Check,
  close: X,
  copy: Copy,
  dashboard: MonitorCheck,// LayoutPanelLeft,
  ellipsis: MoreVertical,
  eye: Eye,
  eyeOff: EyeOff,
  gem: Gem,
  gift: Gift,
  grid3x3: Grid3x3,
  handshake: Handshake,
  chart: ChartCandlestick,
  history: History,
  instagram: Instagram,
  layoutDashboard: LayoutDashboard,
  list: List,
  watchlist: SwatchBook,
  radar: Radar,
  refresh: RefreshCw,
  target: Target,
  trendingUp: TrendingUp,
  waves: Waves,
  zap: Zap,
  gitHub: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="github"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      ></path>
    </svg>
  ),
  google: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="google"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 488 512"
      {...props}
    >
      <path
        d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
        fill="currentColor"
      />
    </svg>
  ),
  nextjs: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="nextjs"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      {...props}
    >
      <path
        fill="currentColor"
        d="m4.5 4.5l.405-.293A.5.5 0 0 0 4 4.5zm3 9.5A6.5 6.5 0 0 1 1 7.5H0A7.5 7.5 0 0 0 7.5 15zM14 7.5A6.5 6.5 0 0 1 7.5 14v1A7.5 7.5 0 0 0 15 7.5zM7.5 1A6.5 6.5 0 0 1 14 7.5h1A7.5 7.5 0 0 0 7.5 0zm0-1A7.5 7.5 0 0 0 0 7.5h1A6.5 6.5 0 0 1 7.5 1zM5 12V4.5H4V12zm-.905-7.207l6.5 9l.81-.586l-6.5-9zM10 4v6h1V4z"
      ></path>
    </svg>
  ),
  help: HelpCircle,
  home: Home,
  laptop: Laptop,
  link: Link,
  lineChart: LineChart,
  logOut: LogOut,
  logo: ChartNoAxesColumn,
  media: Image,
  messages: MessagesSquare,
  moon: Moon,
  package: Package,
  page: File,
  fileSpreadsheet: FileSpreadsheet,
  post: FileText,
  search: Search,
  settings: Settings,
  sparkles: Sparkles,
  spinner: Loader2,
  sun: SunMedium,
  bot: Bot,
  calculator: Calculator,
  compass: Compass,
  play: Play,
  slidersVertical: SlidersVertical,
  trash: Trash,
  twitter: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="twitter"
      role="img"
      {...props}
    >
      <path
        d="M14.258 10.152L23.176 0h-2.113l-7.747 8.813L7.133 0H0l9.352 13.328L0 23.973h2.113l8.176-9.309 6.531 9.309h7.133zm-2.895 3.293l-.949-1.328L2.875 1.56h3.246l6.086 8.523.945 1.328 7.91 11.078h-3.246zm0 0"
        fill="currentColor"
      />
    </svg>
  ),
  telegram: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="telegram"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M446.7 98.5c-4.3-16.1-16.7-28.5-32.8-32.8C402.3 54.8 224 54.8 224 54.8S45.7 54.8 33.1 65.7c-16.1 4.3-28.5 16.7-32.8 32.8C0 110.1 0 256 0 256s0 145.9 1.3 157.5c4.3 16.1 16.7 28.5 32.8 32.8C45.7 457.2 224 457.2 224 457.2s178.3 0 189.9-11c16.1-4.3 28.5-16.7 32.8-32.8C448 401.9 448 256 448 256s0-145.9-1.3-157.5zM192 340.6V171.4l142.1 84.6L192 340.6z"
      ></path>
    </svg>
  ),
  discord: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="discord"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M407.3 64H104.7C46.9 64 0 110.9 0 168.7v174.7C0 401.1 46.9 448 104.7 448h302.6c57.8 0 104.7-46.9 104.7-105.6V168.7C512 110.9 465.1 64 407.3 64zM170.8 202.4c-10.4 0-18.8 8.4-18.8 18.8 0 10.4 8.4 18.8 18.8 18.8 10.4 0 18.8-8.4 18.8-18.8 0-10.4-8.4-18.8-18.8-18.8zm170.4 0c-10.4 0-18.8 8.4-18.8 18.8 0 10.4 8.4 18.8 18.8 18.8 10.4 0 18.8-8.4 18.8-18.8 0-10.4-8.4-18.8-18.8-18.8zM394.6 274.7c-9.8 8.7-23.1 15-38.1 18.2 1.2-1.6 2.2-3.3 3.1-5.1-13.1 1.3-25.6 1.8-37.5 0.8-10.2-0.8-18.8-2.2-25.3-3.4-10.6-1.9-20.6-4-29.5-6.5-2.3-0.7-4.6-1.4-6.7-2.1-2.8-1-5.2-1.8-7.4-2.4-3.6-1.1-6.6-1.9-8.9-1.9-2.4 0-5.2 0.9-8.9 1.9-2.2 0.6-4.7 1.4-7.4 2.4-2.2 0.7-4.4 1.4-6.7 2.1-8.9 2.5-18.8 4.6-29.5 6.5-6.5 1.2-15.1 2.6-25.3 3.4-11.9 1-24.4 0.5-37.5-0.8 0.9 1.8 1.9 3.5 3.1 5.1-15 3.2-28.3-9.5-38.1-18.2-23.2-34.2-36.8-66.8-36.8-101.2 0-34.6 14.6-62.8 42-62.8 20.4 0 38 14.2 44.2 20.8 5 4.6 9.2 10 13.2 15.6 5.2 7.2 7.8 10.8 14.2 10.8 7.2 0 10-3.6 18-10.8 4.4-4.6 9.2-8.4 14.2-11.4 2.8-1.6 5.6-2.8 8.6-2.8 3.4 0 6.4 1.2 9.4 2.8 4.6 3 9.4 6.8 14.6 11.4 7.2 7.2 10 10.8 18 10.8 6.8 0 9.6-2.8 14.2-10 4.8-7.2 9.4-14 14.2-20.8 6.4-7.2 14-20.8 44.2-20.8 27.4 0 42 28.2 42 62.8 0 34.4-13.6 67-36.8 101.2z"
      ></path>
    </svg>
  ),
  user: User,
  users: Users,
  warning: AlertTriangle,
};
